import { PageHero } from "../components/site/PageHero";
import { Eyebrow, FadeUp, MaskedLines } from "../components/site/Reveal";
import { Seal } from "../components/site/Seal";
import { Marquee } from "../components/site/Marquee";
import { WhySection } from "../components/home/WhySection";
import { ClosingCta } from "../components/home/ClosingCta";

const VALUES = ["Integrity", "Accuracy", "Client satisfaction"];

export default function About() {
  return (
    <>
      <PageHero testid="about-hero" eyebrow="About the firm" lines={["Integrity is", <span className="italic text-[#E3C88A]">our first clause.</span>]} />
      <section className="paper py-20 sm:py-32" data-testid="about-overview">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-14 items-center">
          <div className="lg:col-span-7">
            <Eyebrow>Who we are</Eyebrow>
            <h2 className="mt-6 font-display text-3xl sm:text-5xl text-[#0A192F] leading-[1.1]">
              <MaskedLines inView delay={0} lines={["A premier professional consultancy", <span className="italic text-[#8A6A2B]">for civil, legal & property advisory.</span>]} />
            </h2>
            <FadeUp delay={0.15} className="mt-10 space-y-6 text-[#2C3545] text-base sm:text-lg leading-relaxed max-w-2xl">
              <p>Ridhanya Associates is a premier professional consultancy firm dedicated to delivering comprehensive civil, legal, and property advisory services.</p>
              <p>With a commitment to integrity, accuracy, and client satisfaction, we assist individuals, families, and corporate entities in navigating complex property matters, legal documentation, and financial securing.</p>
            </FadeUp>
            <FadeUp delay={0.25} className="mt-12 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {VALUES.map((v, i) => (
                <div key={v} className="rounded-2xl border border-[#0A192F]/15 bg-white p-6" data-testid={`about-value-${i}`}>
                  <span className="font-mono text-xs tracking-[0.25em] text-[#8A6A2B]">0{i + 1}</span>
                  <p className="mt-4 font-display text-2xl text-[#0A192F]">{v}</p>
                </div>
              ))}
            </FadeUp>
          </div>
          <div className="lg:col-span-5 flex justify-center rounded-[28px] bg-[#070F1E] py-16 px-6">
            <Seal size="w-[70vw] max-w-[380px]" />
          </div>
        </div>
      </section>
      <Marquee items={["Individuals", "Families", "Corporate entities", "Guntur", "Andhra Pradesh"]} />
      <WhySection />
      <ClosingCta />
    </>
  );
}
